import React, { useState, useContext, useEffect } from 'react';
import { Modal, Message } from 'semantic-ui-react';
import styles from "./DataConnections.module.css";
import dataconnection from '../../../api/DataConnection/dataconnection';
import { DataContext } from './DataProvider';
import "./CustomModal.css";

const DuplicateDataLayerModal = ({ open, onClose, setDatabases, initFormdata, setLoading, setSuccessMessage }) => {
  const { loaddata, connections, updateConeection } = useContext(DataContext);
  const [formData, setFormData] = useState({
    id: '',
    name: '',
    columns: []
  });
  const [columns, setColumns] = useState([{ name: '', type: '' }]);
  const [errorMessage, setErrorMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const showErrorMessage = (message) => {
    setErrorMessage(message);
    setTimeout(() => {
      setErrorMessage("");
    }, 3000);
  };

  useEffect(() => {
    if (open && initFormdata) {
      const newName = initFormdata.name ? `Copy ${initFormdata.name}` : '';
      setFormData({
        id: initFormdata.id || '',
        name: newName,
        columns: initFormdata.columns || []
      });
      setColumns(initFormdata.columns ? JSON.parse(initFormdata.columns) : [{ name: '', type: '' }]);
    } else {
      handleReset();
    }
  }, [open, initFormdata]);

  const handleReset = () => {
    setFormData({
      id: '',
      name: '',
      columns: []
    });
    setColumns([{ name: '', type: '' }]);
    setErrorMessage("");
    setIsSubmitting(false);
  };

  const handleSubmit = async () => {
    setErrorMessage("");

    const payload = {
      id: formData.id,
      tableName: formData.name,
      columns: columns.map(column => ({
        name: column.name,
        type: column.type
      }))
    };

    try {
      setIsSubmitting(true);
      setLoading(true);
      updateConeection(undefined);

      const res = await dataconnection.addConnection(payload);
      await loaddata();

      setDatabases(res.data);
      updateConeection(res.data);
        setSuccessMessage("Database copied successfully!");
    onClose();

      handleReset();
      
    } catch (error) {
      console.error("Error adding connection:", error);
      showErrorMessage("Failed to duplicate database");
    } finally {
      setLoading(false);
      setIsSubmitting(false);
    }
  };

  

  return (
    <Modal open={open} onClose={onClose} size="small" className="custom-modal">
      <Modal.Content>
        {errorMessage && (
          <Message error>
            <Message.Header>Validation Error</Message.Header>
            <p>{errorMessage}</p>
          </Message>
        )}
        <button 
          type="button" 
          className="close linear-gradient" 
          onClick={onClose} 
          data-dismiss="modal" 
          aria-label="Close"
        >
          X
        </button>
        <div className="modal-header">
          <h5 className="modal-title">Confirm your action</h5>
        </div>
        <p className="custom-modal-content">Are you sure you want to copy this configuration?</p>
      </Modal.Content>
      <div className="modal-footer">
        <button 
          type="button" 
          className="yr-cancelbtn linear-gradient-cancel btn-sm yr-btn-small" 
          onClick={onClose} 
          data-dismiss="modal"
          disabled={isSubmitting}
        >
          <span>No</span>
        </button>
        <button 
          type="button" 
          onClick={handleSubmit} 
          className="btn linear-gradient yr-submitbtn btn-sm" 
          disabled={isSubmitting}
        >
          Yes
        </button>
      </div>
    </Modal>
  );
};

export default DuplicateDataLayerModal;